import { put, select, takeEvery } from 'redux-saga/effects';
import { keyBy } from 'lodash';
import ActionTypes from '../../../../Data/ActionTypes';
import { NAVIGATION_BLOCKS } from '../../../../Data/Constants';
import { setSelectAndConnectBrands } from '../../slices/submission';
import SubmissionStatus from '../../../../Data/SubmissionStatus';
import { getSelectAndConnectComponent } from '../../../../Helpers/supplierMatchPredicates';
import { getSelectedSupplierBrands } from '../../../../Helpers/supplierResolution';

export function* submitSelectAndConnectWorker(action) {
  const { payload } = action;
  const { selectAndConnectPage } = payload;

  const components = yield select((store) => store.components);
  const dynamicMatches = yield select(
    (store) => store.supplierMatches?.dynamicMatches
  );

  try {
    const selectAndConnectComponent = getSelectAndConnectComponent({
      components,
    });

    const selectAndConnectBrands = getSelectedSupplierBrands({
      selectAndConnectComponent,
      dynamicMatches,
    }).map((brand) => ({
      ...brand,
      submissionStatus: SubmissionStatus.NOT_STARTED,
    }));

    /**
     * The navigation block below is only lifted once every brand has submitted,
     * so applying it with nothing to submit would strand the customer on the
     * select and connect page. Work out what there is to submit first.
     */
    if (selectAndConnectBrands.length === 0) {
      return;
    }

    yield put({
      type: 'NAVIGATION_CONTROLS/setNavigationBlockOnPage',
      payload: {
        pageNumber: selectAndConnectPage,
        blockName: NAVIGATION_BLOCKS.SELECT_AND_CONNECT,
        isPreventingNavigation: true,
      },
    });

    yield put(
      setSelectAndConnectBrands({
        selectAndConnectBrands: keyBy(selectAndConnectBrands, 'brandId'),
      })
    );
  } catch (error) {
    yield put({
      type: 'NAVIGATION_CONTROLS/setNavigationBlockOnPage',
      payload: {
        pageNumber: selectAndConnectPage,
        blockName: NAVIGATION_BLOCKS.SELECT_AND_CONNECT,
        isPreventingNavigation: false,
      },
    });
  }
}

export default function* submitSelectAndConnectSaga() {
  yield takeEvery(
    ActionTypes.SUBMIT_SELECT_AND_CONNECT,
    submitSelectAndConnectWorker
  );
}
